import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { Loader2, MailCheck, XCircle } from 'lucide-react';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { verifyEmail } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState('verifying'); // verifying | success | error
  const [msg, setMsg] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setState('error'); setMsg('No verification token provided.'); return; }
    verifyEmail(token)
      .then(() => { setState('success'); setTimeout(() => nav('/dashboard'), 1500); })
      .catch((e) => { setState('error'); setMsg(e?.response?.data?.detail || 'Verification failed.'); });
  }, [token, verifyEmail, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center" data-testid="verify-email-page">
        {state === 'verifying' && (
          <>
            <Loader2 className="w-10 h-10 text-teal-600 animate-spin mx-auto mb-6" />
            <h1 className="font-display font-black text-2xl mb-2">Verifying your email…</h1>
            <p className="text-zinc-500">Hang tight, this only takes a second.</p>
          </>
        )}
        {state === 'success' && (
          <>
            <div className="w-16 h-16 rounded-2xl bg-teal-100 flex items-center justify-center mx-auto mb-6"><MailCheck className="w-8 h-8 text-teal-600" /></div>
            <h1 className="font-display font-black text-3xl mb-2" data-testid="verify-success">Email verified!</h1>
            <p className="text-zinc-600">Taking you to your dashboard…</p>
          </>
        )}
        {state === 'error' && (
          <>
            <div className="w-16 h-16 rounded-2xl bg-red-100 flex items-center justify-center mx-auto mb-6"><XCircle className="w-8 h-8 text-red-600" /></div>
            <h1 className="font-display font-black text-3xl mb-2" data-testid="verify-error">Verification failed</h1>
            <p className="text-zinc-600 mb-8">{msg}</p>
            <Link to="/login" className="btn btn-primary w-full">Go to login</Link>
          </>
        )}
      </div>
    </div>
  );
}
